<h1 mat-dialog-title>Une erreur est survenue!</h1>
<div mat-dialog-content>
  <p>
    Une erreur est survenue lors de la sauvegarde des fichiers de votre produit.
  </p>
  <p>Veuillez réessayez en allant modifier votre produit.</p>
  <p>
    Assurez-vous que la taille totale de vos fichiers ne dépasse pas la limite
    de 100Mo ou 1Go si vous avez un abonnement premium.
  </p>
  <p>
    Si le problème persiste veuillez nous contacter au
    <a href="mailto:support@creasources.ca">support@creasources.ca</a>
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="warn" [mat-dialog-close]="true">
    Fermer
  </button>
</div>
